// src/composables/useRetailerProfile.js
import { ref, computed } from '@vue/composition-api'
import store from '@/store'
import { getProperProfileData } from '@/common-utils'
import analytics from '@/@core/utils/analytics'
import constants from '@/constants'
import { FETCH_PROFILE } from '@/store/modules/auth.module'
import { GET_COMMON_AUTH, GET_COUNTRIES } from '@/store/modules/common.module'

export function useRetailerProfile() {
  // --- Section B: Reactive State ---
  const isLoaded = ref(false)
  const profile = ref({})
  const commons = ref({})
  const countryData = ref({})
  const isCommonDataLoaded = ref(false)
  const addresses = ref([])
  const additionalUsers = ref([])
  const activeTab = ref('general')

  // --- Section C: Computed ---
  const currentEntityId = computed(() => store.state.auth.currentEntityId)

  // --- Section D: BUSINESS methods ---
  function trackPageView(page) {
    analytics.track(constants.TRACKS.PAGES[page])
  }

  async function getCommonAuthData() {
    const res = await store.dispatch(GET_COMMON_AUTH)
    commons.value = res.data.data
  }

  async function getCommonData() {
    const res = await store.dispatch(GET_COUNTRIES)
    countryData.value = res.data.data
    isCommonDataLoaded.value = true
  }

  async function getUserProfile() {
    const res = await store.dispatch(FETCH_PROFILE)
    additionalUsers.value = res?.additionalUsers || []
    profile.value = getProperProfileData(res)
    addresses.value = JSON.parse(JSON.stringify(res?.addresses)) || []
    isLoaded.value = true
  }

  // --- Section D: UI update handlers ---
  function updateGeneral(generalData) {
    profile.value.general = generalData
  }

  function updateSocial(socialData) {
    profile.value.social = socialData
  }

  function updateDocument(documentData) {
    profile.value.documents = documentData
  }

  function updateSegmentation(segmentationData) {
    profile.value.segmentation = segmentationData
  }

  // --- Section I: Init (replaces mounted + created) ---
  function init(routeTabIndex) {
    analytics.track(constants.TRACKS.PAGES.ACCOUNT_SETTING_GENERAL)
    getCommonAuthData()
    getCommonData()
    getUserProfile().then(() => {
      if (routeTabIndex !== undefined) {
        activeTab.value = routeTabIndex
      }
    })
  }

  return {
    // State
    isLoaded,
    profile,
    commons,
    countryData,
    isCommonDataLoaded,
    addresses,
    additionalUsers,
    activeTab,
    // Computed
    currentEntityId,
    // Methods
    trackPageView,
    getCommonAuthData,
    getCommonData,
    getUserProfile,
    updateGeneral,
    updateSocial,
    updateDocument,
    updateSegmentation,
    init,
  }
}
